import {addDays, addHours, truncateDate, tsToDate} from "../../Utilities/DateTimeUtils"
import { eventTemplatesConfig } from "../../../Backend/clubDetails"

export function getAllEventDates(allEvents) {
    const dates = [];
    for(const eventId in allEvents) {
        dates.push(allEvents[eventId].date);
    }
    return dates;
}

// Define constants for days of week
export const SUNDAY = 7;
export const MONDAY = 1;
export const TUESDAY = 2;
export const WEDNESDAY = 3;
export const THURSDAY = 4;
export const FRIDAY = 5;
export const SATURDAY = 6;

function getNextAvailableDay(hour, allEvents, dayOfWeek=null, min=null) {
    let date = today();
    const allEventDates = getAllEventDates(allEvents);
    
    if(dayOfWeek) {
        date.setDate(date.getDate() - date.getDay() + dayOfWeek);
        if(date.getTime() <= today().getTime()) date = addDays(date, 7);
    } else date = addDays(date,1);
    
    let foundAvailableDate = false;
    while(!foundAvailableDate) {
        foundAvailableDate = true;
        for(const date2 of allEventDates) {
            const eventDate = tsToDate(date2);
            // Compare full date (year, month, day)
            if(eventDate.getFullYear() === date.getFullYear() && 
               eventDate.getMonth() === date.getMonth() && 
               eventDate.getDate() === date.getDate()) {
                foundAvailableDate = false;
                break; // No need to check more events once we know there's a conflict
            }
        }
        if(!foundAvailableDate) date = addDays(date, dayOfWeek ? 7 : 1);
    }
    
    if (min !== null) {
        date.setMinutes(min);
    }
    date.setHours(hour);
    return date;
}

export function getEmptyEvent(date){
    const time = truncateDate(new Date(date.valueOf()));
    time.setHours(18);
    return {
        time: time,
        event_type: "Custom Round",
        event_type_option: "Other",
        event_subject: "",
        open_to_jr: true,
        open_to_sr: true,
        open_to_other_clubs: true,
        open_to_non_students: true,
        location: "",
        requestedFeedbacks: false
    };
}

export function today(){
    const date = truncateDate(new Date());
    return date;
}

export function getDefaultEvents(name, allEvents){
    // Get template configuration or empty object if not available
    const templates = eventTemplatesConfig?.templates || {};
    
    // If the requested template doesn't exist or is disabled, fall back to custom
    if (!templates[name] || !templates[name].enabled) {
        name = 'custom';
    }
    
    let date, registration_start, registration_end, check_in_start, events;
    
    switch(name){
        case 'custom':
            date = getNextAvailableDay(0, allEvents);
            events = [getEmptyEvent(date)];
            break;
        default:
            // Get the template configuration
            const template = templates[name];
            const dayOfWeek = template.dayOfWeek;
            
            // Set the base date for this event
            date = getNextAvailableDay(0, allEvents, dayOfWeek);
            
            // Create events based on template definition
            events = [];
            for (const eventConfig of template.events) {
                const eventTime = getNextAvailableDay(
                    eventConfig.hour, 
                    allEvents, 
                    dayOfWeek, 
                    eventConfig.minute
                );
                
                events.push({
                    time: eventTime,
                    event_type: eventConfig.event_type,
                    event_type_option: eventConfig.event_type_option,
                    event_subject: eventConfig.event_subject || "",
                    open_to_jr: eventConfig.open_to_jr,
                    open_to_sr: eventConfig.open_to_sr,
                    open_to_other_clubs: eventConfig.open_to_other_clubs,
                    open_to_non_students: eventConfig.open_to_non_students !== undefined ? 
                        eventConfig.open_to_non_students : true,
                    location: eventConfig.location || "",
                    requestFeedbacks: eventConfig.requestFeedbacks || false
                });
            }
            break;
    }

    // Default registration times:
    registration_start = addHours(new Date(), -1);
    
    // Set registration end time based on configuration
    if (eventTemplatesConfig?.registrationEndHoursAfterStart) {
        registration_end = addHours(new Date(date.valueOf()), eventTemplatesConfig.registrationEndHoursAfterStart);
    } else {
        registration_end = new Date(date.valueOf());
    }

    // Default check in time based on configuration
    const checkInHour = eventTemplatesConfig?.checkInHour || 7;
    check_in_start = addHours(date, checkInHour);

    return {
        date: date,
        registration_start: registration_start,
        registration_end: registration_end,
        check_in_start: check_in_start,
        events: events,
    };
}
